import {
  Card,
  ProductInfo,
  ProductNameContainer,
  ErrorDescription,
} from "./styles";
import { InvalidSubscriptionBreakdownProps } from "./SubscriptionBreakdown.types";
import { Typography } from "@mui/material";

export const InvalidSubscriptionBreakdown = (
  props: Omit<InvalidSubscriptionBreakdownProps, "type">
) => {
  const { productName, errorDescription } = props;

  return (
    <Card>
      <ProductInfo>
        <ProductNameContainer>
          <Typography>{productName}</Typography>
        </ProductNameContainer>
        <ErrorDescription>{errorDescription}</ErrorDescription>
      </ProductInfo>
    </Card>
  );
};
